:host {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.submittal-files-viewer {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.submittal-files-viewer__workflow {
  flex: 0 0 auto;
  max-height: 96px;
  opacity: 1;
  overflow: hidden;
  transition: max-height 0.25s ease, opacity 0.25s ease;
}

.submittal-files-viewer__workflow--hidden {
  max-height: 0;
  opacity: 0;
  pointer-events: none;
}

.submittal-files-viewer file-pages-viewer {
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.submittal-files-viewer__uploader {
  position: absolute;
  bottom: 0;
  left: 50px;
  right: 50px;
  bottom: 20px;
  max-width: 600px;
  overflow: none;
  display: block;
  margin: 0 auto;
}

.submittal-files-viewer__uploader--hidden {
  display: none;
}

.submittal-files-viewer__uploader {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px 8px;
}

.submittal-files-viewer__unaccepted-photos {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
}

.submittal-files-viewer__unaccepted-photo {
  flex: 0 0 auto;
  width: 120px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.submittal-files-viewer__unaccepted-photo-thumb {
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 4px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  cursor: pointer;
}

.submittal-files-viewer__unaccepted-photo-thumb feed-item-accept-button {
  position: absolute;
  top: 0;
  right: 0;
}

.submittal-files-viewer__unaccepted-photo-meta {
  min-width: 0;
}

.submittal-files-viewer__unaccepted-photo-name {
  font-size: 12px;
  font-weight: 500;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.submittal-files-viewer__unaccepted-photo-date {
  font-size: 11px;
  color: #666;
}
